import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { resetFirstLastMargins } from '@/css/resources/placeholders.css';
import { transitions } from '@/css/resources/variables.css';
import {
	expandLink,
	fluidValues,
	fontStyle,
	fluidPadding,
	fluidBorderWidth,
	fluidBorderRadius,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,
			borderColor: styles?.border?.color,

			/* stylelint-disable-next-line */
			'.supt-cardAddress__image': fluidValues(
				'maxWidth',
				styles?.image?.width?.[0],
				styles?.image?.width?.[1],
				true
			),

			'.supt-cardAddress__wrapperContent': cssObj(
				fluidPadding(styles?.padding),
				{
					background: styles?.backgroundColor,
				}
			),

			'.supt-cardAddress__title': fontStyle({
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			}),

			'.supt-cardAddress__text': fontStyle({
				...styles?.text?.typography,
				textAlign: styles?.text?.textAlignment,
				color: styles?.text?.color,
			}),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'stretch',
		width: '100%',
		borderStyle: 'solid',
		overflow: 'hidden',

		'.supt-cardAddress__image': {
			flex: '0 0 100%',
			display: 'flex',
			width: '100%',

			figure: {
				display: 'flex',
				width: '100%',
				height: '100%',
			},

			img: {
				objectFit: 'cover',
			},
		},

		'.supt-cardAddress__wrapperContent': {
			width: '100%',
			display: 'flex',
			alignItems: 'center',
		},

		'.supt-cardAddress__content': {
			width: '100%',
		},

		'.supt-cardAddress__title, .supt-cardAddress__text':
			resetFirstLastMargins,

		/* with link */
		'&.supt-withLink': cssObj(expandLink(), {
			transition: `all ${transitions.mid} ease-out`,

			'.supt-cardAddress__title, .supt-cardAddress__text': {
				transition: `all ${transitions.mid} ease-out`,
			},

			'&:hover, &:focus-within': getDynamicStyles(styles?.states?.hover),
		}),
	});

// edit
const getEditGlobalStyles = (styles) =>
	cssObj({
		'.wp-block[data-type="supt/card-address"]': {
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,

			figure: {
				height: '100% !important',
			},

			'.supt-card': {
				height: '100%',
			},

			'.editor-post-featured-image__preview img': {
				width: '100%',
				height: '100%',
			},
		},
	});

export { getStyles, getEditGlobalStyles };
